var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6826,
    r: 20,
    fill: "#F9FCFF",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6175 19.3426L27.9463 11.9326H26.4462L20.9525 18.3664L16.5625 11.9326H11.5L18.1375 21.6626L11.5 29.4326H13L18.8025 22.6376L23.4388 29.4326H28.5012L21.6175 19.3426ZM19.5638 21.7476L18.8913 20.7789L13.54 13.0701H15.8438L20.1613 19.2914L20.8337 20.2601L26.4475 28.3476H24.1437L19.5638 21.7476Z",
    fill: "#F9FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1d1fd4141d00d014b1ac215f14b82a1b.svg";
export { ForwardRef as ReactComponent };